import { Grid, Typography } from "@mui/material";
import React, { useState } from "react";
import { useFormContext } from "react-hook-form";
import { useSelector } from "react-redux";
import { RadioInput } from "../../../../../components/inputs";

const PregnancyForm = () => {
  const isJoint = useSelector((state) => state?.instruction?.isJoint);
  const arr = useSelector((state) => state?.instruction?.arr);
  const [edit, setEdit] = useState(arr.length > 1 ? [false, false] : [false]);
  const { getValues } = useFormContext();
  const { pregancy_lookupType: pregancy_lookup } = useSelector(
    (state) => state?.lookupData
  );
  const handleEdit = (clientNumber, value) => {
    setEdit((prev) => {
      let temp = prev;
      temp[clientNumber] = value;
      return [...temp];
    });
  };
  return (
    <>
      <Grid item xs={12}>
        <Typography
          variant="h6"
          style={{ fontSize: "bold", marginBottom: "0.5rem" }}
        >
          Pregnancy
        </Typography>
      </Grid>
      <Grid width={"100%"} display={"flex"} flexDirection={"row"}>
        {arr?.map((item, index) => {
          let gender = getValues(
            `InstructionClients[${index}].InstructionFactFind.clientDetails.gender`
          );
          return (
            <Grid
              width={isJoint ? "50%" : "100%"}
              borderTop={`1px solid #DCDCE1`}
              borderBottom={`1px solid #DCDCE1`}
              borderRight={index === 0 ? `1px solid #DCDCE1` : null}
              paddingY={4}
              display={"flex"}
              flexDirection={"column"}
              gap={3}
              paddingRight={index === 0 ? 2 : 0}
              paddingLeft={index === 1 ? 2 : 0}
            >
              <Grid container spacing={3}>
                {gender?.toLowerCase() == "female" && (
                  <Grid item xs={12}>
                    <RadioInput
                      orientation="row"
                      label={`If the Testator were pregnant at the time in which they lose capacity, what would the Testator like to happen?`}
                      name={`InstructionLivingWillQuestionnaire.[${index}].pregnancy`}
                      options={pregancy_lookup}
                    />
                  </Grid>
                )}
              </Grid>
            </Grid>
          );
        })}
      </Grid>
    </>
  );
};

export default PregnancyForm;
